import React from 'react';
import clsx from 'clsx';
import { Text } from '../text';
import { TileMarkup } from './TileEnum';
import { is } from '../../services';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Tile Component
 * @deprecated
 * @param children {ReactNode} Tile Children
 * @param className {string} Additionnal CSS Classes
 * @param onClick {Function} onClick Event
 * @param to {string} link to url
 * @param ancestor {boolean} Tile is an ancestor
 * @param child {boolean} Tile is a child
 * @param parent {boolean} Tile is a parent
 * @param vertical {boolean} Tile is vertical
 * @param markup {TileMarkup} HTML element : div|a
 * @param routerLink Custom Router Link as props
 */
const Tile = ({ children, className, ancestor, child, markup = TileMarkup.DIV, onClick, to, parent, vertical, routerLink, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('tile', ancestor && is('ancestor'), child && is('child'), parent && is('parent'), vertical && is('vertical'), className));
    const Tag = markup;
    const content = Array.isArray(children) ? (children.map((child, index) => {
        return child && typeof child.valueOf() === 'string' ? React.createElement(Text, { key: index }, String(child)) : child;
    })) : children && typeof children.valueOf() === 'string' ? (React.createElement(Text, null, String(children))) : (children);
    if (routerLink && to) {
        const RouterLink = (routerLink ? routerLink : 'a');
        return (React.createElement(RouterLink, { className: classes, onClick: onClick, to: to, ...others }, content));
    }
    return (React.createElement(Tag, { "data-testid": testId, className: classes, ...others, onClick: onClick }, content));
};
export default Tile;
//# sourceMappingURL=Tile.js.map